<template>
  <div class="modal fade" :id="modalId" tabindex="-1" aria-labelledby="imageModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="imageModalLabel">Imagen</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body d-flex justify-content-center align-items-center">
          <img :src="currentImage" alt="Imagen" style="max-width: 100%; max-height: 80vh;" class="d-block mx-auto" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShowImagesModal",
  props: {
    modalId: String,
    currentImage: String,
    currentImageName: String,
  },
};
</script>

